import { ByPhase, ByProject, CostCenterData, IssuerData } from "~/application/types/entities/CustomerBI.type";
import { Box } from "~/components/Box";
import { Card } from "~/components/Card";
import { Flex } from "~/components/Flex";
import { Col } from "~/components/Grid";
import { Text } from "~/components/Text";
import { H4 } from "~/components/Typography";
import { asCurrency } from "~/utils/mask.utils";
import { OnSelectMultiValuesProps } from "../../types";

type ByPhaseResumeProps = {
  phases?: ByPhase[];
  onSelectMultiValues: ({ value, field }: OnSelectMultiValuesProps) => void;
  selectedMultiValues: ByPhaseSelectedValues;
};

type ByPhaseSelectHandler = ({ value, field }: { value: string; field: "phases" }) => void;

type ByPhaseSelectedValues = {
  phases: string[];
};

export function ByPhaseList({
  phases,
  onSelectMultiValues,
  selectedMultiValues,
}: ByPhaseResumeProps) {
  return (
    <>
      <Card css={{ height: "600px" }}>
        <Flex css={{ p: "$5" }}>
          <H4>Valor por fase</H4>
        </Flex>
        <Box css={{ overflow: "auto" }}>
          {phases?.map((phase) => (
            <>
              <Flex
                justify="between"
                key={`isser-resume-${phase.uuid}`}
                onClick={() => onSelectMultiValues({ value: phase.uuid, field: "phases" })}
                css={{
                  p: "$4",
                  borderRadius: "$2",
                  backgroundColor: selectedMultiValues.phases?.includes(phase.uuid)
                    ? "$primary-light"
                    : "transparent",
                  alignItems: "center",
                  borderBottom: "1px solid $neutrals-lightest",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "$neutrals-lightest",
                  },
                }}
              >
                <Flex align="center" gap="4">
                  <Flex gap="1" direction="column" justify="center">
                    <Text fw="600">{phase.name}</Text>
                    <Text css={{ fontSize: "$sm", color: "$neutrals-darkest" }}>
                      Último pedido: {phase.lastOrderDate}
                    </Text>
                  </Flex>
                </Flex>
                <Text fw="700" css={{ color: "$success-base" }}>
                  {asCurrency(phase.value)}
                </Text>
              </Flex>
            </>
          ))}
        </Box>
      </Card>
    </>
  );
}
